<!--page starts-->
<section class="page-wrapper faqs-page">
    <div class="faqs-hero-section margin-top-152 cf" Style="background-image:url(assets/images/faq-banner-img.jpg)">
        <div class="container">
           <div class="faqs-hero-detail">
           	   
           </div>
        </div>
    </div>
    <div class="faqs-bottom-section cf">
        <div class="container">
            <div class="faqs-bottom-detail-main">
                <div class="faqs-bottom-top">  
                    <div class="titel-box">
                        <h2 class="titel-name">faqs</h2>
                    </div>
                </div>
                <div class="faqs-content-main">
                    <div class="faq-features-bottom-inner" *ngIf="faqList?.length > 0">
                        <div class="accordion-container">
                            <div class="set" *ngFor="let faq of faqList">
                              <a href="javascript:void(0)">
                                {{faq?.question}}
                                <span class="fa fa-caret-down"></span>
                              </a>
                              <div class="content" [innerHTML]="faq?.answer">
                              </div>
                            </div>             
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->